import React from 'react';
import PropTypes from 'prop-types';
import MainGridMiddleRightRowDayOffTypePachi from './MainGridMiddleRightRowDayOffTypePachi';

/**
 * MainGridMiddleRightDayOffTypePachi
 */
class MainGridMiddleRightDayOffTypePachi extends React.Component {
  componentDidMount() {
    // const scroll = this.props.scrollTop;
    $('ledger_sheet_scroll').scrollTop = 500;
    // $('myEle').scrollTop(500);
  }

  render() {
    const actions = this.props.actions;
    const MainGridNodes = this.props.dataDayOff.map((maingrid, index) => {
      const cnt = index + 1;
      maingrid['cnt'] = cnt;
      return (
        <MainGridMiddleRightRowDayOffTypePachi dataDayOffItem={maingrid} actions={actions} key={index} />
      );
    });

    return (
      <div className="ledger_sheet_scroll return_x return_y ib bar bar_xy" style={{ width: 'auto', height: '100%' }} onScroll={e => this.props.actions.onScroll(e.target)}>
        <div className="ledger_sheet_scroll_inner scroll_x max_height_target max_height_day row_width_dayoff">
          <div className="modlue center_col ib textright grid_line_bottom">
            {MainGridNodes}
          </div>
        </div>
      </div>
    );
  }
}

MainGridMiddleRightDayOffTypePachi.propTypes = {
  dataDayOff: PropTypes.any.isRequired,
  actions: PropTypes.any.isRequired
};

export default MainGridMiddleRightDayOffTypePachi;
